import { Resource } from "./Resource";
import { ResourceIdentifier } from "./ResourceIdentifier";
import { LogGroup } from ".././MyHelpers";
import {  MyVideo , MyVideoParams } from "../MyVideo";
import { Settings } from "../Settings";

export class VideoResource2 extends Resource
{
	get Name(): string {
		return this.name;
	}
	get Type(): string {
		return "video";
	}
	public video: MyVideo;

	public constructor(params: Partial<MyVideoParams>)
	{
		super(params.src + Settings.videoFormat, params.resid.ID(), true);
		this.video = new MyVideo(params);

		this.video.AddOnMetaDataLoadedCallback(() => {
			if (!this.processed)
			{
				this.Loaded();
			}
		});

		this.video.AddOnMetaDataErrorCallback(() => {
			if (!this.processed)
			{
				this.LoadError();
			}
		});
	}

	public override Load(preventCache: boolean = false): void
	{
		this.video.LoadMetaData();
	}

	public override Reload(preventCache: boolean = false): void
	{
		this.processed = false;
		this.video.Reload();
	}
}


export enum VideoPreloadType
{
	metadata = "metadata",
	auto = "auto"
}

export class VideoResource extends Resource
{
	get Name(): string {
		return this.name;
	}
	get Type(): string {
		return "video"
	}
	
	protected resid: ResourceIdentifier;
	protected logGroup: LogGroup;

	public video: HTMLVideoElement;


	protected readonly preload: VideoPreloadType = VideoPreloadType.auto;

	public constructor(path: string, resid: ResourceIdentifier, logGroup: LogGroup = null)
	{
		super(path + Settings.videoFormat, resid.ID(), true);

		this.resid = resid;
		this.logGroup = logGroup;
	}

	public Load(preventCache: boolean = false): void
	{
		
		this.video = document.createElement("video");
		this.video.classList.add(this.resid.ID());

		this.video.src = this.path;
		this.video.preload = this.preload;

		this.video.onerror = () => {
			//Log.Error(this.logGroup, "onerror");

			if (!this.processed)
			{
				this.LoadError();
			}
		}

		// this.video.onloadstart = () => {
		// 	Log.Error(this.logGroup, "onloadstart");
		// }

		if (this.preload == VideoPreloadType.metadata)
		{
			this.video.onloadedmetadata = () => {
				//Log.Error(this.logGroup, "onloadedmetadata");

				if (!this.processed)
				{
					this.Loaded();
				}
			}
		}

		// this.video.onloadend = () => {
		// 	Log.Error(this.logGroup, "onloadend");
		// }

		// enough video has loaded, so it can start to play
		if (this.preload == VideoPreloadType.auto)
		{
			this.video.oncanplay = () => {
				//Log.Error(this.logGroup, "oncanplay");

				if (!this.processed)
				{
					this.Loaded();
				}
			}
		}

		// this.video.onplay = () => {
		// 	Log.Error(this.logGroup, "onplay");
		// }

		// this.video.onpause = () => {
		// 	Log.Error(this.logGroup, "onpause");
		// }

		//Log.Error(this.logGroup, "load started");

		this.video.load();
	}

	public override Reload(preventCache: boolean = false): void
	{
		this.video.src = "";
		this.Load(preventCache);
	}
}